import React from 'react'
import { Paper, withStyles, Grid, TextField, Button,
        InputAdornment, IconButton } from '@material-ui/core'
import { Face, Fingerprint, Visibility, VisibilityOff } from '@material-ui/icons'
import axios from 'axios'
import axiosCookieJarSupport from 'axios-cookiejar-support'
import {setAuth, setName, setRoles, setToken} from '../redux/auth'
import { setSelectedModule } from '../redux/navigation'
import { baseApiAuth } from "../modules/db";
import {theme} from '../theme'


import tough from 'tough-cookie'
axiosCookieJarSupport(axios)
const cookieJar = new tough.CookieJar();

const styles = theme => ({
    margin: {
        margin: 10,
    },
    padding: {
        padding: 5
    }
})

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state =  
            {
                name: "",
                password: "",
                remember: false,
                showPassword: false,
            }
      }
    doSignUp = () => {
        setSelectedModule('SignUp')
    }

    doLogin = () => {

        const user = {...this.state}
        //axios.post('http://haccp-dev.iqkitchen.biz/couch/_session', {
        axios.post(`${baseApiAuth}/auth/login`, {
            email: user.name,
            password: user.password
        }).then(function (response) {
            if(response.status===200) {
                axios.post(`${baseApiAuth}/auth/roles`, {},        
                {
                    headers: { Authorization : `Bearer ${response.data.token}` }
                },
                ).then( resp => {
                    const {data} = resp
                    let stop = false
                    let roles 
                    data.map( rol => {
                        if(!stop){
                            if(rol.role_name == 'HACCP Coordinator'){
                                roles = ['admin','haccpwriter']
                                setRoles(roles)
                                stop = true
                            }
                            else{
                                roles = ['haccpwriter']
                                setRoles(roles)
                            }
                                
                            
                        }
                    })
                    localStorage.setItem('session', JSON.stringify({
                        logged: true,
                        token: response.data.token,
                        name: user.name,
                        roles,
                    }))
                })
                setToken(response.data.token)
                setName(user.name)
                setAuth(true) 
            }
          }).catch( (e) => {
            alert('Verify your credentials!')
            //console.log(e)
          })
    }
    keyPressed = (ev) => {
        if (ev.key === "Enter") {
            this.doLogin()
        }
    }

    handleFormChange = (event) => {
        let res = {...this.state}
        res[event.target.id]=event.target.value
        if(event.target.id==='name'){res['_id']= 'org.couchdb.user:'+event.target.value}
        this.setState(res)
        localStorage.setItem('loginformdata',  JSON.stringify(res))
    }

    handleCheck = () => {
        this.setState({
            remember: !this.state.remember
        })
    }

    render() {
        const { classes } = this.props
        const { colors } = theme
        return (
            <Paper className={classes.padding} style={{ 
                color: colors.secondary
            }} >
                <div className={classes.margin}>
                    <Grid container spacing={8} alignItems="flex-end">
                        <Grid item>
                            <Face />
                        </Grid>
                        <Grid item md={true} sm={true} xs={true}>
                            <TextField 
                                id="name" 
                                label="Username"
                                fullWidth autoFocus required
                                style={{ 
                                    textTransform: "none", 
                                }} 
                                value={this.state.remember ? JSON.parse(localStorage.getItem('loginformdata')).name : this.state.name}
                                onChange={this.handleFormChange}
                                onKeyPress={this.keyPressed}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={8} alignItems="flex-end">
                        <Grid item>
                            <Fingerprint />
                        </Grid>
                        <Grid item md={true} sm={true} xs={true}>
                            <TextField
                                style={{ 
                                    textTransform: "none", 
                                }} 
                                id="password" 
                                label="Password" 
                                type={this.state.showPassword ? 'text' : 'password'}
                                fullWidth required 
                                value={this.state.remember ? JSON.parse(localStorage.getItem('loginformdata')).password : this.state.password} 
                                onChange={(e) => this.handleFormChange(e)}
                                onKeyPress={(e)=> this.keyPressed(e)}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={() => {this.setState({showPassword: !this.state.showPassword})}}
                                      onMouseDown={ e => e.preventDefault()}
                                      edge="end"
                                    >
                                      {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                  </InputAdornment>,
                                }}
                            />  
                        </Grid>
                    </Grid>
                    { /*
                    <Grid container alignItems="center" justify="space-around">
                        <Grid item>
                            <FormControlLabel control={
                                <Checkbox
                                    color="primary"
                                    onChange={this.handleCheck}
                                />
                            } label="Remember me" />
                        </Grid>
                      
                            <Grid item>
                                <Button disableFocusRipple disableRipple style={{ textTransform: "none" }} variant="text" color="primary">Forgot password ?</Button>
                            </Grid>
                      
                    </Grid> */ }
                    
                    <Grid container justify="center" style={{ marginTop: '10px' }}>
                        <Button 
                            variant="contained"
                            style={{ 
                                backgroundColor: colors.primary, 
                                color: colors.light,
                                marginRight:30
                            }}
                            onClick={this.doLogin}
                        >Login</Button>
                        <Button 
                            variant="outlined" 
                            color={colors.secondary} 
                            style={{ 
                                textTransform: "none", 
                                color: colors.secondary
                            }}
                            
                            onClick={this.doSignUp}
                        >Sign Up</Button>
                    </Grid>
                </div>
            </Paper>
        )
    }
}

export default withStyles(styles)(Login)